import {ENVIRONMENT_PROD} from '../models/environment';

declare global {
    interface Window {
        config?: {
            paths?: Array<never>,
            themePath?: string,
            googleMapsApiKey?: string,
            environment?: string,
            language?: string,
        };
    }
}

export default class EnvironmentProvider {
    current: string;

    constructor() {
        if (Object.hasOwnProperty.call(window, 'config')) {
            this.current = window.config?.environment || ENVIRONMENT_PROD;
        }
    }
}
